module.exports = function() {
  return new Worker(__webpack_public_path__ + "cc9a7578d1bf28cee961.worker.js");
};